import { CmObjectType } from '@svta/cml-cta'

/**
 * Common Media Server Data Object Type
 *
 *
 * @enum
 *
 * @beta
 */
export const CmsdObjectType = CmObjectType as typeof CmObjectType

/**
 * @beta
 */
export type CmsdObjectType = CmObjectType;
